module.exports = __webpack_public_path__ + "img/rise_logo_black.705fcaf6.svg";